module.exports = __webpack_public_path__ + "img/47.fca20398.png";